// Eterna Goods D3 mobile drawer: drill-in sub panels (event delegation, no polling).
(() => {
  if (window.__egD3) return;
  window.__egD3 = true;

  const showRoot = (root, animate) => {
    const rootPanel = root.querySelector('[data-eg-d3-root]');
    root.querySelectorAll('[data-eg-d3-panel]').forEach((p) => { p.hidden = true; });
    let opener = null;
    root.querySelectorAll('[data-eg-d3-open]').forEach((a) => {
      if (a.getAttribute('aria-expanded') === 'true') opener = a;
      a.setAttribute('aria-expanded', 'false');
    });
    if (!rootPanel) return;
    rootPanel.hidden = false;
    rootPanel.classList.toggle('eg-d3--back', !!animate);
    const drawer = root.closest('.menu-drawer');
    if (drawer) drawer.scrollTop = 0;
    if (opener && animate) opener.focus({ preventScroll: true });
  };

  document.addEventListener('click', (e) => {
    const root = e.target.closest && e.target.closest('[data-eg-d3]');
    if (!root) return;
    const open = e.target.closest('[data-eg-d3-open]');
    if (open) {
      const panel = root.querySelector('#' + CSS.escape(open.dataset.egD3Open));
      if (!panel) return; // no panel: follow the link normally
      e.preventDefault();
      const rootPanel = root.querySelector('[data-eg-d3-root]');
      if (rootPanel) { rootPanel.hidden = true; rootPanel.classList.remove('eg-d3--back'); }
      panel.hidden = false;
      open.setAttribute('aria-expanded', 'true');
      const drawer = root.closest('.menu-drawer');
      if (drawer) drawer.scrollTop = 0;
      const back = panel.querySelector('[data-eg-d3-back]');
      if (back) back.focus({ preventScroll: true });
      return;
    }
    if (e.target.closest('[data-eg-d3-back]')) {
      e.preventDefault();
      showRoot(root, true);
    }
  });

  // Reset to the top level whenever the drawer closes (toggle does not bubble, so use capture).
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || d.open) return;
    const root = d.querySelector(':scope [data-eg-d3]');
    if (root && d.id === 'Details-menu-drawer-container') showRoot(root, false);
  }, true);
})();
